import { CalendarTableM } from './CalendarTableM';

export const AfterDataHtmlM = (props: AfterDataHtmlMProps) => {
  return (
    <div className='flex flex-wrap justify-center gap-[37px] lg:gap-[57px]'>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={0} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={1} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={2} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={3} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={4} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={5} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={6} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={7} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={8} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={9} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={10} />
      </div>
      <div className='w-[315px]'>
        <CalendarTableM data={props.data} year={props.year} month={11} />
      </div>
    </div>
  );
};
